module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/provider/provider-preferences.component.css
// module id = ./src/app/views/provider/provider-preferences.component.css
// module chunks = main